import React, { useEffect, useRef, useState } from 'react';
import { cn } from 'helpers/utils/classnames';
import { AmpPromotionEvent } from '../../../../types/gtm-events/Ecommerce';
import { useAccount, useCart } from '../../../frontastic';
import { gtmSelectPromotion, gtmViewPromotion } from '../../../helpers/utils/gtm-events/gtmEccomerce';
import { observeElementsInViewport } from '../../../helpers/utils/viewportObserver';

interface GTMWrapperProps {
  gtmEvents: AmpPromotionEvent[];
  children: React.ReactElement | React.ReactElement[];
  className?: string;
}

const GTMWrapper: React.FC<GTMWrapperProps> = ({ gtmEvents, children, className }) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const { account } = useAccount();
  const { data: cart } = useCart();
  const [observerInitialised, setObeserverInitialised] = useState(false);

  useEffect(() => {
    if (!cart || observerInitialised || !ref.current) return;

    const gtmViewEvent = gtmEvents?.find((e) => e.eventKey === 'VIEW_PROMOTION');
    if (gtmViewEvent) {
      setObeserverInitialised(true);
      observeElementsInViewport({
        element: ref.current,
        callback: () => {
          gtmViewPromotion(
            Object.fromEntries(gtmViewEvent.eventData.map(({ key, value }) => [key, value])),
            cart,
            account,
          );
        },
      });
    }
  }, [cart]);

  const onClick = () => {
    const gtmSelectEvent = gtmEvents?.find((e) => e.eventKey === 'SELECT_PROMOTION');
    if (gtmSelectEvent) {
      gtmSelectPromotion(
        Object.fromEntries(gtmSelectEvent.eventData.map(({ key, value }) => [key, value])),
        cart,
        account,
      );
    }
  };

  if (!gtmEvents?.length) return <div className={cn(className)}>{children}</div>;

  return (
    <div className={cn(className)} ref={ref} onClick={onClick}>
      {children}
    </div>
  );
};

export default GTMWrapper;
